module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Filters","filters":{"name":"Name","gpu":"GPU","cpu":"CPU","memoryAmount":"RAM","imageFileId":"With images","screen":"Screen"}}}')
  delete Component.options._Ctor
}
